import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const DigitalAnchorVisual = () => {
  const t = useT();

  return (
    <GenPage
      title={t('page.digitalAnchorVisual.title')}
      contentType="digitalAnchorVisual"
      description={t('page.digitalAnchorVisual.desc')}
      outputLabel={t('page.digitalAnchorVisual.output')}
      hideWebSearch
    />
  );
};
